import { useState, useEffect, createRef } from 'react';
import { Col, Row, Divider, Table } from 'antd';
import Form from 'react-bootstrap/Form';
import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import RicercaCodiceSvc from 'services/ricercaCodice';
import Loading from 'components/loading';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleDown } from '@fortawesome/free-solid-svg-icons';
import '../../css/_ricercaCodice.scss';

const RicercaCodice = ({ isMobile, resetCounter, defaultSkip, queryString }) => {
  const typeaheadRef = createRef();

  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [valueList, setValueList] = useState([]);
  const [filteredValueList, setFilteredValueList] = useState([]);
  const [checked, setChecked] = useState();
  const [selectedValue, setSelectedValue] = useState();
  const [selected, setSelected] = useState(false);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [oldCounter, setOldCounter] = useState(1);

  useEffect(() => {
    if (resetCounter !== oldCounter) {
      setSelectedValue();
      setSelected(false);
      setChecked();
      setIsChecked(false);
      setColumns([]);
      setRows([]);
      typeaheadRef.current.clear();

      setOldCounter(resetCounter);
    }
  }, [resetCounter]);

  useEffect(() => {
    if (defaultSkip) defaultSkip(true);
    if (queryString) queryString('');
    document.title = 'Ricerca codice Istat - SITUAS';
    let mounted = false;
    const fetchList = async () => {
      try {
        const { data } = await RicercaCodiceSvc.getList();
        if (!mounted) {
          setList(data.items);
          setLoading(false);
        }
      } catch {
        setLoading(false);
      }
    };
    fetchList();
    return () => {
      mounted = true;
    };
  }, []);
  useEffect(() => { }, [isChecked, selected]);

  useEffect(() => {
    let mounted = false;
    if (!mounted) {
      setSelectedValue();
    }
    const fetchValueList = async () => {
      if (checked) {
        setLoading(true);
        try {
          const { data } = await RicercaCodiceSvc.getValueList(checked.return_code);
          if (!mounted) {
            setValueList(data?.resultset);
            setFilteredValueList(
              data?.resultset.map(({ V, RC }) => ({ label: V, value: RC, key: V + RC }))
            );
            setLoading(false);
          }
        } catch {
          setLoading(false);
        }
      }
    };
    fetchValueList();
    return () => {
      mounted = true;
    };
  }, [checked]);

  const executeSearch = () => {
    const mounted = false;
    if (!mounted) {
      if (selected) {
        setLoading(true);
      }
      setColumns([]);
      setRows([]);
    }
    const getDetail = async () => {
      try {
        const { data } = await RicercaCodiceSvc.getDetail(checked.return_code, selectedValue.value);
        const formattedCols = Object.keys(data.resultset[0]).map((key) => ({
          //title: _.capitalize(key.replaceAll('_', ' ')),
          title: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          }),
          dataIndex: key,
          key: key
        }));
        const formattedRows = data.resultset.map((row) => {
          const rowVal = Object.values(row);
          let rowObject = { key: rowVal[0] + rowVal[rowVal.length - 1] };
          Object.keys(row).forEach((value) => {
            rowObject = { ...rowObject, [value]: row[value] };
          });
          return rowObject;
        });
        if (!mounted) {
          setColumns(formattedCols);
          setRows(formattedRows);
          setLoading(false);
        }
      } catch {
        setLoading(false);
      }
    };
    if (selectedValue && selected) {
      getDetail();
    }
  }; /* , [selectedValue, selected, checked?.return_code] */

  const search = (inputValue) => {
    setSelected(false);
    setSelectedValue({ label: inputValue });
    if (inputValue?.length > 0) {
      let filtered = valueList
        .filter((value) =>
          value.V.split('-')[1].toLowerCase().trim().startsWith(inputValue.toLowerCase())
        )
        .map(({ V, RC }) => ({ label: V, value: RC, key: V + RC }));

      if (!filtered.length) {
        filtered = valueList
          .filter((value) =>
            value.V.split('-')[0].toLowerCase().trim().startsWith(inputValue.toLowerCase())
          )
          .map(({ V, RC }) => ({ label: V, value: RC, key: V + RC }));
      }

      if (!filtered.length) {
        filtered = valueList
          .filter((value) => value.V.toLowerCase().trim().startsWith(inputValue.toLowerCase()))
          .map(({ V, RC }) => ({ label: V, value: RC, key: V + RC }));
      }
      setFilteredValueList(filtered);
    } else {
      setFilteredValueList(valueList.map(({ V, RC }) => ({ label: V, value: RC, key: V + RC })));
    }
  };
  const searchCodice = (inputValue) => {
    setSelected(false);
    setSelectedValue({ label: inputValue });
    if (inputValue?.length > 0) {
      const filtered = valueList
        .filter((value) =>
          value.V.split('-')[0].toLowerCase().trim().startsWith(inputValue.toLowerCase())
        )
        .map(({ V, RC }) => {
          ({ label: V, value: RC, key: V + RC });
        });
      setFilteredValueList(filtered);
    } else {
      setFilteredValueList(valueList.map(({ V, RC }) => ({ label: V, value: RC, key: V + RC })));
    }
  };

  return (
    <main id="main-content" className={`pb-4 pt-3 pb-4 bs-docs-section clearfix`}>
      {loading && <Loading fullPage />}
      <Row className="box">
        <Col sm={23} lg={7}>
          <form className="mt-5 pt-2 d-flex flex-column justify-content-start storia-ua-criteri-container" role="search" name="Criteri di ricerca">
            <div>
              <fieldset role="radiogroup" aria-describedby="criteri-desc">
                <legend className="text-secondary">Criteri di ricerca</legend>
                <p className="sr-only" id="criteri-desc">
                  I risultati vengono mostrati simultaneamente all'impostazione dei filtri
                </p>

                {list.map(({ return_code, label_tipologia }, idx) => {
                  return (
                    <Form.Check
                      id={'criteri-' + idx}
                      type="radio"
                      name="criteri"
                      tabIndex={0}
                      aria-label={label_tipologia}
                      key={label_tipologia}
                      className="ml-2"
                      label={label_tipologia}
                      checked={checked?.label_tipologia === label_tipologia}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setChecked({ return_code, label_tipologia });
                          setSelectedValue();
                          setSelected(false);
                          setIsChecked(true);
                        } else {
                          setChecked();
                          setIsChecked(false);
                          setSelectedValue();
                          setSelected(false);
                        }
                        typeaheadRef.current?.clear();
                      }}
                    />
                  );
                })}
              </fieldset>
            </div>
            <div>
              <p id='cerca-desc' className='sr-only'>
                {(!checked || !selected) ? 'Popolare i filtri di ricerca per abilitare il pulsante.' : ''}
              </p>
              <fieldset>
                <p id='codice-ricerca-desc' className='sr-only'>, selezionare un'unità territoriale per abilitare la casella di ricerca.</p>
                <Typeahead
                  ref={typeaheadRef}
                  id="codice-ricerca-typeahead"
                  className="codice-ricerca-denominazione mt-2 mb-3"
                  tabIndex={0}
                  open={(checked && valueList.length > 0) ? undefined : false}
                  inputProps={{
                      id:"codice-ricerca",
                      "aria-disabled":(!checked || !valueList.length > 0),
                      "aria-describedby":(checked && valueList.length > 0) ? '' : 'codice-ricerca-desc',
                      className:(checked && valueList.length > 0) ? '' : 'criteri-ricerca-input-disabled',
                      readOnly:(!checked || !valueList.length > 0)
                    }}
                  placeholder={(checked && valueList.length > 0) ? `Codice/Denominazione ${checked?.label_tipologia}` : ''}
                  onKeyDown={(event) => {
                    if (event.key === "Enter")
                      event.preventDefault();
                  }}
                  onChange={(selection) => {
                    if (selection && selection.length === 1) {
                      const option = new Object(selection[0]);
                      setSelectedValue(option);
                      setSelected(option.value !== '');
                    }
                  }}
                  onBlur={(event) => {
                    if(event?.target.value === ''){
                      setSelected(false);
                    }
                  }}
                  value={selectedValue?.label}
                  options={filteredValueList}
                  renderMenu={(results) => (
                    <Menu id='codice-ricerca-menu-options' aria-label='Opzioni menù' className='storiaua-typeahead-menu-options' emptyLabel='Nessun dato'>
                      {results.map((result, index) => (
                        <MenuItem option={result} position={index} key={`codice-ricerca-option-${index}`} aria-live='polite' aria-atomic='true'>
                          {result.paginationOption ?
                            <><FontAwesomeIcon className="typeahead-pagination-icon mr-2" aria-hidden="true" icon={faChevronCircleDown} />Carica più risultati</>
                            :
                            result.label
                          }
                        </MenuItem>
                      ))}
                    </Menu>
                  )}
                  paginationText="Carica più risultati"
                />
              </fieldset>
            </div>
            <button
              tabIndex={0}
              type="button"
              aria-describedby='cerca-desc'
              aria-disabled={!checked || !selected}
              className={`storia-ua-button mt-2 ${!checked || !selected ? 'btn-search-disabled' : ''}`}
              onClick={() => {
                executeSearch();
              }}
            >
              Cerca
            </button>
            <button
              tabIndex={0}
              className="storia-ua-button"
              type="submit"
              onClick={() => {
                setSelectedValue();
                setSelected(false);
                setChecked();
                setIsChecked(false);
                setColumns([]);
                setRows([]);
                typeaheadRef.current.clear();
              }}>
              Annulla
            </button>
          </form>
        </Col>
        <Col role="status" aria-live="polite"
          sm={23}
          lg={16}
          offset={1}>
          <h2 className="title-main">Ricerca codice Istat</h2>
          <Divider className="blue-divider" />
          {!columns.length > 0 && (
            <span>
              Dopo aver selezionato l'unità e ricercato codice-denominazione di interesse, il sistema restituisce l'elenco dei codici e denominazioni dell'unità stessa con relativo periodo di validità.
            </span>
          )}
          <div className="d-flex justify-content-start">
            {!columns.length > 0 ? (
              <span></span>
            ) : (
              <>
                <span className="sr-only">{selectedValue ? `Ricerca per ${checked?.label_tipologia} ${selectedValue?.label}; ` : ''}</span>
                <Table
                  className="mb-5 no-wrap"
                  scroll={{ x: 500 }}
                  bordered
                  dataSource={rows}
                  columns={columns}
                  pagination={false}
                />
              </>
            )}
          </div>
        </Col>
      </Row>
    </main>
  );
};
export default RicercaCodice;
